import { render } from "./StudentSkillAssessmentDataTable.vue?vue&type=template&id=755c9be1&scoped=true"
import script from "./StudentSkillAssessmentDataTable.vue?vue&type=script&lang=js"
export * from "./StudentSkillAssessmentDataTable.vue?vue&type=script&lang=js"

import "./StudentSkillAssessmentDataTable.vue?vue&type=style&index=0&id=755c9be1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-755c9be1"]])

export default __exports__